import { CredentialsFetchers } from './algolia-client-provider';
import { AlgoliaParamsInterface } from './algolia-params.interface';
import { InjectionToken } from '@angular/core';

export const ALGOLIA_SERVICE_TOKEN = new InjectionToken<AlgoliaParamsInterface>('ALGOLIA_SERVICE_TOKEN');
export const ALGOLIA_CREDENTIALS_FETCHERS_TOKEN = new InjectionToken<CredentialsFetchers>('ALGOLIA_SERVICE_TOKEN');
